export default __webpack_public_path__ + "static/media/honeycomb.7eb9e5eb.svg";